<script setup>
import { courseDays, quotes } from '../../config/pageData.js';
</script>

<template>
  <section class="m-sec">
    <div class="m-center">
      <span class="m-kicker">三 日 公 開 課</span>
    </div>
    <h2 class="m-title">三日課程，日日有真章</h2>
    <p class="m-sub">由淺入深：第一日建立信任睇懂八字，第二日實修減壓，第三日升維到人生智慧。</p>

    <div class="m-cards">
      <div
        v-for="(c, i) in courseDays"
        :key="i"
        class="m-card"
      >
        <img
          :src="c.image"
          :alt="c.title"
          class="m-card-img"
          loading="lazy"
        />
        <div class="m-card-body">
          <div class="m-card-day">{{ c.day }}</div>
          <h3 class="m-card-title">{{ c.title }}</h3>
          <p class="m-card-desc">{{ c.desc }}</p>
          <div class="m-card-len">{{ c.len }}</div>
        </div>
      </div>
    </div>

    <div class="m-quotes">
      <div
        v-for="(q, i) in quotes"
        :key="i"
        class="m-quote"
      >
        <p class="m-quote-text">{{ q.text }}</p>
        <small class="m-quote-from">{{ q.from }}</small>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.m-sec {
  padding: 96px 32px;
}

.m-center {
  text-align: center;
}

.m-kicker {
  display: inline-block;
  font-size: 24px;
  letter-spacing: 8px;
  color: #a8823f;
  border: 2px solid #c9a25e;
  padding: 8px 24px;
  border-radius: 999px;
  margin-bottom: 24px;
}

.m-title {
  font-size: 44px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  color: #16241d;
  letter-spacing: 1px;
}

.m-sub {
  text-align: center;
  color: #6f6a5c;
  font-size: 26px;
  margin-top: 18px;
}

.m-cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 28px;
  margin-top: 44px;
}

.m-card {
  background: #fff;
  border: 1px solid #e7dfcc;
  border-radius: 18px;
  overflow: hidden;
  text-align: center;
}

.m-card-img {
  width: 100%;
  aspect-ratio: 20 / 11;
  object-fit: cover;
  display: block;
}

.m-card-body {
  padding: 28px 26px 32px;
}

.m-card-day {
  font-size: 23px;
  letter-spacing: 6px;
  color: #a8823f;
  margin-bottom: 10px;
}

.m-card-title {
  font-size: 34px;
  font-weight: 700;
  color: #16241d;
}

.m-card-desc {
  font-size: 26px;
  color: #6f6a5c;
  margin-top: 14px;
}

.m-card-len {
  margin-top: 18px;
  font-size: 22px;
  color: #a49d8a;
}

.m-quotes {
  display: grid;
  grid-template-columns: 1fr;
  gap: 22px;
  margin-top: 40px;
}

.m-quote {
  position: relative;
  background: #fff;
  border: 1px solid #e7dfcc;
  border-radius: 18px;
  padding: 34px 28px;

  &::before {
    content: '「';
    position: absolute;
    top: 12px;
    left: 18px;
    font-size: 52px;
    color: #c9a25e;
    opacity: 0.55;
    line-height: 1;
  }
}

.m-quote-text {
  position: relative;
  margin-top: 28px;
  font-size: 30px;
  font-weight: 700;
  color: #16241d;
  padding-left: 16px;
}

.m-quote-from {
  display: block;
  margin-top: 12px;
  font-size: 22px;
  color: #6f6a5c;
}
</style>
